/**
 * Insights context (read model), the time-window filter for the business
 * dashboard. Pure: no I/O. Every metric aggregates either over all history or
 * over the last 30 days; the window bounds on booking.created_at ("activity in
 * the last 30 days"), applied uniformly across every metric so the toggle reads
 * consistently. Shape only, the read model enforces no rules
 * (02-context-map.md §3). The SQL bound itself lives in the data layer.
 */

/** All-time (default) or a rolling last-30-days window. */
export type PeriodKey = "all" | "30d";

export const DEFAULT_PERIOD: PeriodKey = "all";

/** Days in the rolling window, or null for all-time (no lower bound). */
export const PERIOD_WINDOW_DAYS = 30;

/** A URL query value: absent, single, or repeated. */
type Raw = string | string[] | undefined;

/**
 * Parse the raw `?period=` value. Anything other than an exact "30d" degrades
 * to all-time: the dashboard is forgiving, never an error.
 */
export function parsePeriod(raw: Raw): PeriodKey {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value === "30d" ? "30d" : DEFAULT_PERIOD;
}

/** Lower-bound length in days for the window, or null for all-time. */
export function periodWindowDays(period: PeriodKey): number | null {
  return period === "30d" ? PERIOD_WINDOW_DAYS : null;
}

/** Human label for the active window (dashboard header + toggle). */
export function periodLabel(period: PeriodKey): string {
  return period === "30d" ? "Last 30 days" : "All time";
}
